/* global __API_ROOT_URL__, window, document, URL, Blob */
import * as R from 'ramda';
import angular from 'angular';
import constants from 'app/constants';

let _$http;
let _$timeout;
let _utilityService;

class reportsDataService {
  constructor(
    $http,
    $timeout,

    utilityService, // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _$timeout = $timeout;
    _utilityService = utilityService;
    this.mimeTypeMapping = {
      PDF: 'application/pdf',
      EXCEL: 'application/vnd.ms-excel',
    };
    console.log('app.services.reportsDataService created');
  }

  // Report Families
  getReportFamilies() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/family/byUser`,
      method: 'GET',
      params: {},
    });
  }

  // Report Groups
  getReportGroups(applicationId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/group/byApplication`,
      method: 'GET',
      params: {
        applicationId,
      },
    });
  }

  // Report Types
  getReportTypes() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/filterable`,
      method: 'GET',
      params: {},
    });
  }

  // Report Instances
  getCustomerReportInstanceSummary() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/summary/customer`,
      method: 'GET',
      params: {},
    });
  }

  getReportInstance(id) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/${id}`,
      method: 'GET',
      params: {},
    });
  }

  // Archived Report Instances

  getArchivedReportInstanceSummary() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/summary/archived`,
      method: 'GET',
      params: {},
    });
  }

  getArchivedReportInstances(uniqueId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/${uniqueId}/instancesByUniqueId/archived`,
      method: 'GET',
      params: {},
    });
  }

  deleteArchivedReportInstance(reportInstanceArchiveId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/archived/${reportInstanceArchiveId}`,
      method: 'DELETE',
      params: {},
    });
  }

  bulkDeleteArchivedReportInstances(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/archived/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  // My Report Instances
  
  getMyReportInstanceSummary() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/summary/user`,
      method: 'GET',
      params: {},
    });
  }

  getMyReportInstances(uniqueId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/${uniqueId}/instancesByUniqueId/user`,
      method: 'GET',
      params: {},
    });
  }


  archiveReportInstance(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/archive/${reportInstanceId}`,
      method: 'PUT',
      params: {},
    });
  }

  getArchiveConflicts(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instances/archiveConflicts`,
      method: 'GET',
      params: {
        idList,
      },
    });
  }

  bulkArchiveReportInstances(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/bulkArchive`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteReportInstance(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/${reportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  bulkDeleteReportInstances(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instance/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  // Advisory Reports

  getAdvisoryReportSummary() {
    return _$http({
      url: `${__API_ROOT_URL__}/advisoryReport/summary`,
      method: 'GET',
      params: {
      },
    });
  }

  // Scheduled Reports

  getScheduledReportSummary(appId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportSchedule/summary`,
      method: 'GET',
      params: {
        appId,
      },
    });
  }

  getCustomerReportInstances(reportId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/${reportId}/instances`,
      method: 'GET',
      params: {},
    });
  }

  getCustomerReportInstancesByUId(uniqueId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/${uniqueId}/instancesByUniqueId`,
      method: 'GET',
      params: {},
    });
  }

  getMyReportSchedules(reportGroupId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportSchedule/byReportGroupAndUser/${reportGroupId}`,
      method: 'GET',
      params: {},
    });
  }

  getSchedule(customerScheduleId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportSchedule/${customerScheduleId}`,
      method: 'GET',
      params: {},
    });
  }

  // Acknowledge Statuses
  getAcknowledgeStatuses() {
    return _$http({
      url: `${__API_ROOT_URL__}/acknowledgeStatus/`,
      method: 'GET',
      params: {},
    });
  }

  saveAcknowledgeStatus(reportInstanceId, acknowledgeStatusId, acknowledgedById, reviewDate, noteText) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instances/${reportInstanceId}/updateAcknowledgeStatus`,
      method: 'PUT',
      data: _utilityService.serializeData({
        acknowledgeStatusId,
        acknowledgedById,
        commentText: noteText,
        reviewDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // Report Statuses
  getReportStatuses() {
    return _$http({
      url: `${__API_ROOT_URL__}/report/reportStatus`,
      method: 'GET',
      params: {},
    });
  }

  getReportInstanceStatuses(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceStatus/byReportInstance`,
      method: 'GET',
      params: {
        reportInstanceId,
      },
    });
  }

  deleteReportInstanceStatus(reportInstanceStatusId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceStatus/${reportInstanceStatusId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // Report Instance Notes
  getReportInstanceNote(reportInstanceCommentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceComment/${reportInstanceCommentId}`,
      method: 'GET',
      params: {},
    });
  }

  getReportInstanceNotes(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceComment/byReportInstance`,
      method: 'GET',
      params: {
        reportInstanceId,
      },
    });
  }

  saveReportInstanceNote(reportInstanceComment) {
    if (reportInstanceComment.reportInstanceCommentId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/reportInstanceComment/${reportInstanceComment.reportInstanceCommentId}`,
        method: 'PUT',
        data: JSON.stringify(reportInstanceComment),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/Json' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceComment`,
      method: 'POST',
      data: JSON.stringify(reportInstanceComment),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteReportInstanceNote(reportInstanceCommentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportInstanceComment/${reportInstanceCommentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  // Report Packages
  getOldPackagedReports() {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/customer/old`,
      method: 'GET',
      params: {},
    });
  }

  getNewPackagedReports() {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/customer/new`,
      method: 'GET',
      params: {},
    });
  }

  getReportPackage(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/${reportPackageId}`,
      method: 'GET',
      params: {},
    });
  }

  getReportPackageParameterSummary(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/summaryByReportPackage/${reportPackageId}`,
      method: 'GET',
      params: {},
    });
  }

  deleteReportPackageReportInstance(reportPackageReportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportInstance/${reportPackageReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  getReportPackageParameter(reportPackageReportParameterId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/${reportPackageReportParameterId}`,
      method: 'GET',
      params: {},
    });
  }

  deleteReportPackageReportParameter(reportPackageReportParameterId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/${reportPackageReportParameterId}`,
      method: 'DELETE',
      params: {},
    });
  }

  deleteReportPackage(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/${reportPackageId}`,
      method: 'DELETE',
      params: {},
    });
  }

  deleteGeneratedPackageExecution(reportPackageGenerationQueueId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageGenerationQueue/${reportPackageGenerationQueueId}`,
      method: 'DELETE',
      params: {},
    });
  }

  getGeneratedPackageExecutions(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageGenerationQueue/byReportPackage/${reportPackageId}`,
      method: 'GET',
      params: {},
    });
  }

  getPackagedReportAttachments(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/${reportPackageId}/reportPackageReportInstance`,
      method: 'GET',
      params: {},
    });
  }

  getReportPackageReportsByReportPackage(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/${reportPackageId}/reportPackageReportInstance`,
      method: 'GET',
      params: {},
    });
  }

  generatePackageFileList(reportPackageId) {
    return _$http.post(
      `${__API_ROOT_URL__}/reportPackage`,
      {},
      {
        params: {
          action: 'generatePackageFileList',
          reportPackageId,
        },
      },
    );
  }

  createPackageFileGenerationRequest(reportPackageId) {
    return _$http.post(`${__API_ROOT_URL__}/reportPackage/${reportPackageId}/generatePackage`, {}, {});
  }

  attachReportPackageReport(reportPackageId, reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportInstance`,
      method: 'POST',
      data: _utilityService.serializeData({
        reportPackageId,
        reportInstanceId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  attachReportPackageArchivedReport(reportPackageId, reportInstanceArchiveId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportInstance`,
      method: 'POST',
      data: _utilityService.serializeData({
        reportPackageId,
        reportInstanceArchiveId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachReportPackageReport(reportPackageReportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportInstance/${reportPackageReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }

  detachReportPackageArchivedReport(reportPackageReportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportInstance/${reportPackageReportInstanceId}`,
      method: 'DELETE',
      params: {},
    });
  }


  saveReportPackage(reportPackage) {
    if (reportPackage.reportPackageId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/reportPackage/${reportPackage.reportPackageId}`,
        method: 'PUT',
        data: JSON.stringify(reportPackage),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/Json' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage`,
      method: 'POST',
      data: JSON.stringify(reportPackage),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  checkReportPackageExists(name, reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/checkExists`,
      method: 'GET',
      params: {
        id: reportPackageId,
        name,
      },
    });
  }

  // Report Schedules
  deleteSchedule(customerScheduleId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportSchedule/${customerScheduleId}`,
      method: 'DELETE',
      params: {},
    });
  }

  saveSchedule(schedule) {
    const s = {
      customerScheduleId: schedule.customerScheduleId,
      reportId: schedule.reportId,
      reportGroupId: schedule.reportGroupId,
      scheduleName: schedule.scheduleName,
      scheduleDescription: schedule.scheduleDescription,
      renderFormat: schedule.renderFormat,
      saveByFileName: schedule.saveByFileName,
      parameters: JSON.stringify(schedule.submittedParameters),
      delivery: schedule.delivery,
    };

    if (s.customerScheduleId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/reportSchedule/${s.customerScheduleId}`,
        method: 'PUT',
        data: JSON.stringify(s),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/Json' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/reportSchedule`,
      method: 'POST',
      data: JSON.stringify(s),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  publishReportInstance(reportInstanceId, familyId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instances/${reportInstanceId}/publish`,
      method: 'PUT',
      params: {
        familyId,
      },
    });
  }

  unpublishReportInstance(reportInstanceId, destinationId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/instances/${reportInstanceId}/unpublish`,
      method: 'PUT',
      params: {
        destinationId,
      },
    });
  }

  // getPortalReportsByName(bankId, categoryId, reportName) {
  // return _$http({
  //   method: 'GET',
  //   url: _paths.handlers.ajaxManager,
  //   params: {
  //     action: 'getPortalReportsByName',
  //     bankId: bankId,
  //     categoryId: categoryId,
  //     reportName: reportName,
  //   },
  // });
  // }

  getReportsByService(serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/byService`,
      method: 'GET',
      params: {
        serviceId,
        includeHiddenParameters: false,
      },
    });
  }

  getDependantValues(reportGroupId, parameterId, filterId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/parameter/byFilter`,
      method: 'GET',
      params: {
        reportGroupId,
        parameterId,
        filterId,
      },
    });
  }

  getDependantScheduleValues(reportGroupId, scheduleParameterId, filterId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/scheduleParameter/byFilter`,
      method: 'GET',
      params: {
        reportGroupId,
        scheduleParameterId,
        filterId,
      },
    });
  }

  getReportsByGroup(groupId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/byGroup`,
      method: 'GET',
      params: {
        groupId,
        includeHiddenParameters: false,
      },
    });
  }

  getReportByName(reportName) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportByName/${reportName}`,
      method: 'GET',
      params: {
        reportName,
      },
    });
  }

  getReport(reportGroupId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/ByReportGroup`,
      method: 'GET',
      params: {
        reportGroupId,
        includeHiddenParameters: false,
        parameterType: 1, // Ad-hoc
      },
    });
  }

  getScheduledReport(reportGroupId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/ByReportGroup`,
      method: 'GET',
      params: {
        reportGroupId,
        includeHiddenParameters: false,
        parameterType: 0, // Scheduled
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  generateReport(serviceId, reportId, parameters, saveDocument) {
    const data = {
      parameters: JSON.stringify(parameters),
      saveDocument,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/report/render/${serviceId}/${reportId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  generateAppReport(serviceId, reportId, renderFormat, parameters, saveDocument) {
    const data = {
      parameters: JSON.stringify(parameters),
      renderFormat,
      saveDocument,
      saveLocation: 1 /** Financial Institution Reports */,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/report/render/${serviceId}/${reportId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  generateAppReportByReportGroup(reportGroupId, renderFormat, parameters, saveDocument) {
    let paramString = null;

    if (parameters) {
      paramString = JSON.stringify(parameters);
    }

    const data = {
      parameters: paramString,
      renderFormat,
      saveDocument,
      saveLocation: 2 /** My Reports */,
    };

    return _$http({
      url: `${__API_ROOT_URL__}/report/render/reportgroup/${reportGroupId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  generateTicketReport(ticketId) {
    return _$http({
      url: `${__API_ROOT_URL__}/salesForce/ticket/${ticketId}/print`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'arraybuffer',
    });
  }

  downloadReport(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/${reportInstanceId}/download`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  downloadArchivedReport(reportInstanceArchiveId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/archive/${reportInstanceArchiveId}/download`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  downloadPackage(reportPackageId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackage/${reportPackageId}/download`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  downloadGeneratedPackage(reportPackageGenerationQueueId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageGenerationQueue/${reportPackageGenerationQueueId}/download`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  download(response) {
    const contentType = response.headers('Content-Type');
    const contentDisposition = response.headers('Content-Disposition');
    let fileName = '';

    if (!R.isNil(contentDisposition)) {
      // const matches = /filename="(.*?)"/g.exec(contentDisposition);
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      fileName = matches && matches.length > 1 ? matches[1] : null;
      fileName = fileName.split('"').join('');
    }

    const blob = new Blob([response.data], { type: contentType });
    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = fileName;
      anchor.target = '_self';
      anchor.click();

      // const anchor = document.createElement('a');
      // const url = URL.createObjectURL(blob, { oneTimeOnly: true });
      // anchor.href = url;
      // anchor.target = '_blank';
      // anchor.click();
    }
  }

  getReportBlob(reportInstanceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/${reportInstanceId}/view`,
      method: 'GET',
      responseType: 'blob',
    });
  }

  getArchivedReportBlob(id) {
    return _$http({
      url: `${__API_ROOT_URL__}/report/Instance/archived/${id}/view`,
      method: 'GET',
      responseType: 'blob',
    });
  }

  viewReportBlob(viewReportResponse) {
    const contentDisposition = viewReportResponse.headers('Content-Disposition');
    const contentType = viewReportResponse.headers('Content-Type');
    let fileName = '';

    if (!R.isNil(contentDisposition)) {
      // const matches = /filename="(.*?)"/g.exec(contentDisposition);
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      fileName = matches && matches.length > 1 ? matches[1] : null;
      fileName = fileName.split('"').join('');
    }

    const anchor = document.createElement('a');
    document.body.appendChild(anchor);
    anchor.setAttribute('type', 'hidden');

    const blob = new Blob([viewReportResponse.data], { type: contentType });

    anchor.href = URL.createObjectURL(blob);
    if (contentType !== 'application/pdf') {
      anchor.download = fileName;
    }
    anchor.target = '_blank';
    _$timeout(() => {
      anchor.click();
    }, 0);
  }

  viewAppReport(serviceId, reportId, renderFormat, parameters, saveDocument) {
    const data = {
      parameters: JSON.stringify(parameters),
      renderFormat,
      saveDocument,
      saveLocation: 1 /** Financial Institution Reports */,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/report/render/${serviceId}/${reportId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    });
  }

  viewAppReportByGroup(groupId, reportId, renderFormat, parameters, saveDocument) {
    const data = {
      parameters: JSON.stringify(parameters),
      renderFormat,
      saveDocument,
      saveLocation: 1 /** Financial Institution Reports */,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/report/render/group/${groupId}/${reportId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    });
  }

  viewAppReportByReportGroup(reportGroupId, renderFormat, parameters, saveDocument) {
    let paramString = null;

    if (parameters) {
      paramString = JSON.stringify(parameters);
    }

    const data = {
      parameters: paramString,
      renderFormat,
      saveDocument,
      saveLocation: 2 /** My Reports */,
    };

    return _$http({
      url: `${__API_ROOT_URL__}/report/render/reportgroup/${reportGroupId}`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    });
  }

  // Report Package Report Parameters 
  
  saveBulkReportParameterReportTypes(reportPackageId, reportTypes) {
    const data = {
      reportPackageId,
      reportTypes,
      echo: true,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/reportTypeBulkSave`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getReportParameterReportType(id) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/${id}`,
      method: 'GET',
      params: {
      },
    });
  }

  getReportParameterReportTypesByReportPackage(reportPackageId, reportKind, includeParameters) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/byReportPackageAndKind/${reportPackageId}`,
      method: 'GET',
      params: {
        reportKind,
        includeParameters
      },
    });
  }

  getReportParameterReportTypesByReportPackageAndReport(reportPackageId, reportId) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/parametersByReportPackageAndReport/${reportPackageId}/${reportId}`,
      method: 'GET',
      params: {
      },
    });
  }

  saveBulkReportParameterReportParameters(reportPackageId, reportTypes) {
    const data = {
      reportPackageId,
      reportTypes,
      echo: true,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/reportParameterBulkSave`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // Report Package Advisory Parameters

  saveBulkReportParameterAdvisoryReportTypes(reportPackageId, advisoryReportTypes) {
    const data = {
      reportPackageId,
      advisoryReportTypes,
      echo: true,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/advisoryReportTypeBulkSave`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }
  
  getReportParameterAdvisoryReportTypesByReportPackage(reportPackageId, includeParameters) {
    return _$http({
      url: `${__API_ROOT_URL__}/reportPackageReportParameter/byReportPackageAndKind/${reportPackageId}`,
      method: 'GET',
      params: {
        reportKind: 2,
        includeParameters
      },
    });
  }

  // Dashboards

  getDashboardHtml() {
    return _$http({
      url: `${__API_ROOT_URL__}/dashboard/dashboard/test2`,
      method: 'GET',
    });
  }

  getAllWidgetsHtml() {
    return _$http({
      url: `${__API_ROOT_URL__}/dashboard/dashboard/byType/1`,
      method: 'GET',
    });
  }

  getWidgetHtml(id) {
    return _$http({
      url: `${__API_ROOT_URL__}/dashboard/widget/${id}/renderToHtml`,
      method: 'GET',
    });
  }

  getWidgetImage(id) {
    return _$http({
      url: `${__API_ROOT_URL__}/dashboard/widget/${id}/render`,
      method: 'GET',
    });
  }

  getWidgetBatch(ids) {
    return _$http({
      url: `${__API_ROOT_URL__}/dashboard/widget/renderBatch`,
      method: 'POST',
      data: JSON.stringify(ids),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }
}

reportsDataService.$inject = ['$http', '$timeout', 'utilityService'];

export default angular
  .module('app.services.reportsDataService', [constants])
  .service('reportsDataService', reportsDataService).name;
